import type { CSSProperties } from 'react';

export const STATUS_BACKGROUND_MAPPING: Record<string, CSSProperties> = {
  pending: { backgroundColor: '#f6c44a' },
  ready: { backgroundColor: '#008000' },
  observation: { backgroundColor: '#7E57C2' },
  inpatient: { backgroundColor: '#3065A3' },
  ed: { backgroundColor: '#50AFBD' },
  conflicts_pending: { backgroundColor: '#F14C2E' },
  completed: { backgroundColor: '#008000' },
  finalized_a2: { backgroundColor: '#f6c44a' },
  finalized_a1: { backgroundColor: '#f6c44a' },
  draft: { backgroundColor: '#d3d4d7' },
};
